<template>
    <div v-if="journey && journey.timeline" class="timeline">
        <div class="timeline__start">Start</div>
        <timeline-block v-for="(block, index) in journey.timeline.timelineBlocks" :key="`timeline-block-${index}`" :pieces="pieces" :block="block"></timeline-block>
        <div class="timeline__finish">Finish</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import TimelineBlock from '@/views/Tracking/components/Aside/JourneyTimeline/TimelineBlock'
import TrackingService from "@/services/TrackingService";

export default {
    name: 'JourneyTimeline',
    components: { TimelineBlock },
    data () {
        return {
            journey: null
        }
    },
    mounted () {
        if (0 > this.selectedJourney.length) {
            return
        }

        this.journey = this.selectedJourney[0]
    },
    watch: {
        selectedJourney: {
            handler () {
                if (0 > this.selectedJourney.length) {
                    return
                }

                this.journey = this.selectedJourney[0]
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters({
            selectedJourney: 'trackingModule/getSelectedJourneys'
        }),
        pieces () {
            let pieces = moment(this.journey.timeline.endTime).diff(moment(this.journey.timeline.startTime), 'seconds')

            return pieces
        }
    }

}
</script>

<style scoped lang="scss">
.timeline {
    display: flex;
    height: calc(100% - 60px);
    flex-flow: column;

    &__start,
    &__finish {
        width: 100%;
        padding: 7px 0;
        text-transform: uppercase;
        font-size: 12px;
        background: $secondary;
        color: $white;
        font-weight: bold;
        text-align: center;
    }
}
</style>
